import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";

const { Option } = Select;

function AssigneeTimeLog({ projects }) {
    const [assignee, setAssignee] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(moment());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [series, setSeries] = useState({
        0: {
            hidden: false,
            color: "blue",
            altColor: "transparent",
            lineWidth: 2,
            isVisible: true,
            targetAxisIndex: 0,
        },
        1: {
            hidden: false,
            color: "red",
            altColor: "transparent",
            lineWidth: 2,
            isVisible: true,
            targetAxisIndex: 1,
        },
    });
    const chartOptions = {
        ...columnChartConfigurationOptions,
        curveType: "function",
        title: "WorkLogs and Tickets By Months",
        series: series,
        vAxes: {
            0: { title: "Tickets" },
            1: { title: "Time" },
        },
    };

    const [defaultFormData, setDefaultFormData] = useState({
        assignee_id: "",
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
    });
    const { status, data: assigneeRes } = useQuery("assignee", async () => {
        return await HTTP("/analytics/getJiraAssignees", { staff_id });
    });

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "columnChart",
        async () => {
            return await HTTP("/analytics/getJiraTimingByMonth", {
                ...defaultFormData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        refetch();
    }, [defaultFormData]);

    useEffect(() => {
        if (status === "success") {
            setAssignee(assigneeRes.data);
        }
    }, [status, assigneeRes]);

    useEffect(() => {
        if (columnChartStatus === "success") {
            setColumnChartData(columnChartDataRes.data);
        }
    }, [columnChartStatus, columnChartDataRes]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const formData = {
            ...defaultFormData,
            range_year: yearSelected,
        };
        setDefaultFormData(formData);
    }

    function handleProjectSelectionChange(e) {
        let project_id = -1;
        if (e !== undefined) {
            [project_id] = e.split("#");
        }

        const formData = {
            ...defaultFormData,
            project_id,
        };
        setDefaultFormData(formData);
    }

    function handleAssigneeSelectionChange(e) {
        let assignee_id = "";
        if (e !== undefined) {
            [assignee_id] = e.split("#");
        }

        const formData = {
            ...defaultFormData,
            assignee_id,
        };
        setDefaultFormData(formData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    className="jira-dashboard-select"
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Assignee"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {columnChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="LineChart"
                    height="50vh"
                    legendToggle
                    options={chartOptions}
                    chartEvents={[
                        {
                            eventName: "select",
                            callback: ({ chartWrapper }) => {
                                const chart = chartWrapper.getChart();
                                const selection = chart.getSelection();

                                if (selection.length === 1) {
                                    const [selectedItem] = selection;
                                    const { column } = selectedItem;

                                    if (selection[0].row === null) {
                                        // Legent is pressed
                                        if (series[column - 1].isVisible) {
                                            setSeries({
                                                ...series,
                                                [column - 1]: {
                                                    ...series[column - 1],
                                                    lineWidth: 0, // fake hide
                                                    tooltip: false, // disable tooltips so you can't get tooltip when you hover the area where one point of "inivisibe" line is
                                                    isVisible: false, // our internal flag
                                                },
                                            });
                                        } else {
                                            setSeries({
                                                ...series,
                                                [column - 1]: {
                                                    ...series[column - 1],
                                                    lineWidth: 2,
                                                    tooltip: true,
                                                    isVisible: true,
                                                },
                                            });
                                        }
                                    }
                                }
                            },
                        },
                    ]}
                    data={columnChartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default AssigneeTimeLog;
